import {create} from "zustand";
import axios from "axios";
import {api} from "./api";

export const useOtherStore = create((set, get) => ({
    houses: [],
    myHouses: [],
    videos: [],
    services: [],
    employees: [],
    about: [],
    ad: [],
    house: null,
    employee: null,
    loading: false,
    error: null,
    getServices: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/main-page-information`
            );
            set({
                services: data.services,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getEmployees: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/main-page-information`
            );
            set({
                employees: data.specialists,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getVideos: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/main-page-information`
            );
            set({
                videos: data.video_feedbacks,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getAbout: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/main-page-information`
            );
            set({
                about: data.about_company,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getAd: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/main-page-information`
            );
            set({
                ad: data.ad_blog,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getHouses: async (
        category_id,
        district,
        q,
        min_price_som,
        max_price_som,
        created_from,
        created_to
    ) => {
        set({loading: true, error: null});
        try {
            const params = new URLSearchParams({
                page_size: 20,
                ...(category_id && {category_id}),
                ...(district && {district}),
                ...(q && {q}),
                ...(min_price_som && {min_price_som}),
                ...(max_price_som && {max_price_som}),
                ...(created_from && {created_from}),
                ...(created_to && {created_to}),
            });

            const url = `${api}/public/realty-list?${params.toString()}`;

            const {data} = await axios.get(url);

            set({
                houses: data.items,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getHouseById: async (id) => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/realty-info/${id}`
            );
            set({
                house: data,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getMyHouses: async (
        token,
        category_id,
        district,
        q,
        min_price_som,
        max_price_som,
        created_from,
        created_to
    ) => {
        set({ loading: true, error: null });
        try {
            const params = new URLSearchParams({
                page_size: 20,
                ...(category_id && { category_id }),
                ...(district && { district }),
                ...(q && { q }),
                ...(min_price_som && { min_price_som }),
                ...(max_price_som && { max_price_som }),
                ...(created_from && { created_from }),
                ...(created_to && { created_to }),
            });

            const url = `${api}/realty/list?${params.toString()}`;

            const { data } = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            set({
                myHouses: data.items,
                loading: false,
            });
            return data;
        } catch (e) {
            localStorage.clear();
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            window.location.href = "/login";
        }
    },

    getEmployeeById: async (id) => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/specialist/${id}`
            );
            set({
                employee: data,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
}));

export const useGetVideos = () => useOtherStore((state) => state.getVideos);
export const useVideos = () => useOtherStore((state) => state.videos);
export const useGetEmployees = () => useOtherStore((state) => state.getEmployees);
export const useEmployees = () => useOtherStore((state) => state.employees);
export const useGetEmployeeById = () => useOtherStore((state) => state.getEmployeeById);
export const useEmployee = () => useOtherStore((state) => state.employee);
export const useGetServices = () => useOtherStore((state) => state.getServices);
export const useServices = () => useOtherStore((state) => state.services);
export const useGetAbout = () => useOtherStore((state) => state.getAbout);
export const useAbout = () => useOtherStore((state) => state.about);
export const useGetAd = () => useOtherStore((state) => state.getAd);
export const useAd = () => useOtherStore((state) => state.ad);
export const useGetHouses = () => useOtherStore((state) => state.getHouses);
export const useHouses = () => useOtherStore((state) => state.houses);
export const useGetMyHouses = () => useOtherStore((state) => state.getMyHouses);
export const useMyHouses = () => useOtherStore((state) => state.myHouses);
export const useGetHouseById = () => useOtherStore((state) => state.getHouseById);
export const useHouse = () => useOtherStore((state) => state.house);